import { useState } from "react";
import { Grid } from "@mui/material";
import { ControlPoint as ControlPointIcon, ControlPointDuplicate as ControlPointDuplicateIcon } from "@mui/icons-material"
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getSubcategoriesByCategory, updateActive, updateOrder } from "./services/api";
import { SnackbarGlobal } from "components/Snackbar";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { StyledMenu } from "components/Styled";
import { useTranslation } from "react-i18next";
import { ActionsDialogPage, ActionsMenuPage } from "./ActionsPage";
import { HeaderSectionMultiButton } from "components/Builder/HeaderSection";
import { ReactBeautifulDNDUpdateOrder, getActive } from "../routeHelpers";
import { DraggableRowButtonMenu, DraggableRowDragIndicatorIcon, DraggableRowImage, DraggableRowText } from "components/Builder/DraggableRow";
import { ActiveSwitch } from "../ActionsPage";

export function Subcategories({ menu, category, subcategorySelected }) {
  const { t } = useTranslation();
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [instanceSelected, setInstanceSelected] = useState({})
  const [loadingUpdateActive, setLoadingUpdateActive] = useState(false)
  const [itemIdToUpdateActive, setItemIdToUpdateActive] = useState(null)
  const queryClient = useQueryClient()
  const { data: categoriesByMenu } = useQuery(
    ['categoriesByMenu', category, menu], () => getSubcategoriesByCategory(category, menu),
    { refetchOnWindowFocus: false, enabled: category !== null && category !== undefined }
  )

  const handleResetActions = () => { setOpenAction(0) }
  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleResetActions(); queryClient.invalidateQueries('categoriesByMenu') }
  }

  const [anchorElMenuActions, setAnchorElMenuActions] = useState(null)
  const open = Boolean(anchorElMenuActions)
  const handleClickMenuActions = (event, item) => {
    setAnchorElMenuActions(event.currentTarget); setInstanceSelected(item);
  }
  const handleCloseMenuActions = () => setAnchorElMenuActions(null)
  const handleMenuItemClick = (option) => { setOpenAction(option); handleCloseMenuActions(); }

  const mutation = useMutation(updateOrder, {
    onSuccess: (data) => { if (data.status === "success") { handleWatchAction(true, 'Acción realizada correctamente', 'success') } }
  })
  const handlerOrder = (params) => mutation.mutate(params)
  const handleDrop = (droppedItem) => {
    const order = ReactBeautifulDNDUpdateOrder(categoriesByMenu.data, droppedItem)
    if (order === false) return
    handlerOrder({ value: order })
  }

  const mutationUpdateActive = useMutation(updateActive, {
    onSuccess: (data) => {
      setLoadingUpdateActive(false)
      setItemIdToUpdateActive(null)
      if (data.status === "error") { handleWatchAction(false, 'Error al guardar los datos', 'error') }
      else { handleWatchAction(true, 'Acción realizada correctamente', 'success') }
    }
  })
  const handleUpdateActive = (item) => {
    setLoadingUpdateActive(true)
    setItemIdToUpdateActive(item._id)
    mutationUpdateActive.mutate({ id: item._id, params: { active: !item.active } })
  }

  return (<>
    <HeaderSectionMultiButton
      headerTitle={t('builder_subcategories_title')}
      disabled={false}
      buttons={[
        { title: t('button_text_add'), action: setOpenAction, refAction: 1, icon: <ControlPointIcon /> },
        { title: `${t('button_text_add')} Multi`, action: setOpenAction, refAction: 6, icon: <ControlPointDuplicateIcon /> },
      ]} />
    <Grid container spacing={0}>
      {categoriesByMenu !== undefined ?
        <Grid item xs={12}>
          {categoriesByMenu.data.length > 0 ?
            <DragDropContext onDragEnd={handleDrop}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <Grid container spacing={0} className="droppable" {...provided.droppableProps} ref={provided.innerRef}>
                    {categoriesByMenu.data.map((category, index) => (
                      <Draggable key={`${index}-${category._id}`} draggableId={category._id} index={index} isDragDisabled={false}>
                        {(provided) => (
                          <Grid ref={provided.innerRef} {...provided.draggableProps} container spacing={0} sx={{ padding: "10px 0px", alignItems: "center", borderTop: "1px solid rgba(224, 224, 224, 1)" }}>
                            <Grid item xs={1} {...provided.dragHandleProps}> <DraggableRowDragIndicatorIcon /> </Grid>
                            <Grid item xs={2}> <DraggableRowImage image={category.image} /> </Grid>
                            <Grid item xs={5}>
                              <div style={{ cursor: 'pointer' }} onClick={() => subcategorySelected(category)}>
                                <DraggableRowText text={category.name} />
                              </div>
                            </Grid>
                            <Grid item xs={3} sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                              <DraggableRowButtonMenu
                                open={open}
                                action={(event) => handleClickMenuActions(event, category)} />
                              <ActiveSwitch
                                id={category._id}
                                loadingUpdateActive={loadingUpdateActive}
                                itemIdToUpdateActive={itemIdToUpdateActive}
                                getActive={getActive}
                                data={categoriesByMenu.data}
                                disabled={false}
                                onClick={() => handleUpdateActive(category)} />
                            </Grid>
                          </Grid>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Grid>
                )}
              </Droppable>
            </DragDropContext>
            : <p>NO hay registros</p>}
        </Grid>
        : null}
    </Grid>
    <StyledMenu
      id={`demo-customized-category`}
      MenuListProps={{ 'aria-labelledby': `demo-customized-button-category` }}
      anchorEl={anchorElMenuActions}
      open={open}
      onClose={handleCloseMenuActions} >
      <ActionsMenuPage t={t} action={handleMenuItemClick} conditionsToShow={{
        7: instanceSelected.presentation === 1
      }} />
    </StyledMenu>
    <ActionsDialogPage
      open={openAction}
      close={() => handleResetActions()}
      menu={menu}
      category={category}
      instance={instanceSelected}
      reportAction={handleWatchAction} />
    <SnackbarGlobal
      open={notification.open}
      close={() => setNotification({ open: false, message: "", severity: "" })}
      message={notification.message}
      severity={notification.severity} />
  </>)
}